module.exports = __webpack_public_path__ + "static/city1-051fbed1f52a238140681cfd0856b349.svg";